import React from "react";
import MaterialTable from 'material-table';
import tableicons from "../tableicons";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import {withRouter} from "react-router";
import DialogExportar from "./DialogExportar";
import SnackbarAlert from "./SnackbarAlert";
import Grid from "@material-ui/core/Grid";
import SvgIcon from "@material-ui/core/SvgIcon";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DialogEnviarCorreo from "./DialogEnviarCorreo";
import {inventarioResources} from "../endpoints";
import useToken from "../useToken";

class TablaDiferencias extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos: [],
            seleccionados:[],
            selectedRow:null,
            cargando: true,
            openExportar:false,
            openSnack:false,
            severity:"",
            message:"",
            enviar: false,
            content:"",
            title:"",
            titulo_columna: "",

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({datos:nextProps.datos, cargando:false})
        let datos_inv = useToken.getDatos()
        this.setState({cliente:datos_inv.app},()=>{
            if (this.state.cliente === 'sodimac') {
                this.setState({titulo_columna:"costo"})
            }
            else{
                this.setState({titulo_columna:"importe"})
            }}
        )
    }

    verDetalles = (rowData) =>{
        if(rowData !== null){
            if (this.state.cliente === 'sodimac' || this.state.cliente === 'sodimac_auditoria') {
                this.props.history.push("/detalle_diferencia/jerarquia/"+ rowData.id +"/" + rowData.cantidad +"/" + rowData.filtro)
            }
            else{
                window.open("/detalle_diferencia/jerarquia/"+ rowData.id +"/" + rowData.cantidad +"/" + rowData.filtro, "_blank");
            }
        }
        else{
            if (this.state.cliente === 'sodimac' || this.state.cliente === 'sodimac_auditoria') {
                this.props.history.push("/detalle_diferencia/jerarquia/"+ -1+"/" + -1+"/" + -1)
            }
            else{
                window.open("/detalle_diferencia/jerarquia/"+ -1+"/" + -1+"/" + -1, "_blank");
            }
        }
    }

    verTagsValidados = () =>{
        window.open("/tags_validados");
        //this.props.history.push("/tags_validados")
    }

    refrescarExportar =(estado,severity) =>{
        this.setState({
            openSnack: false
        }, () => {
            this.setState({openSnack:false, severity:null, message:null})
            if(estado){
                this.setState({
                    openExportar: false,
                    enviar:false,
                    openSnack: true,
                    message: estado,
                    severity: severity})
            }
        });
    }

    handleClose = () =>{
        this.setState({openExportar:false, enviar:false})
    }

    enviarDatosReportes =(nombre)=>{
        if(nombre === "variance" || nombre === "variance_walmart" ||nombre === "variance_smu"){
            let params = this.state.seleccionados
            let reporte = nombre
            this.setState({openExportar: true, reporte: reporte, params: params,openSnack:false})
        }
        else{
            let params = ""
            let reporte = nombre
            this.setState({openExportar: true, reporte: reporte, params: params,openSnack:false})
        }
    }

    agregarEnvases = ()=>{
        this.setState({openSnack:false, severity:null, message:null})
        inventarioResources.agregarEnvases().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.setState({
                    openSnack: true,
                    severity: result.severity,
                    datos: useToken.getDatos(),
                    message: result.message,
                })
            }
            else{
                throw new Error('Something went wrong ...');
            }

        }).catch(error=> {
            console.error(error);
            this.setState({
                openSnack: true,
                severity: 'error',
                message: "Error al cambiar el inventario actual"
            })
        });
    }

    render() {
        const cliente = this.state.cliente;
        let button;
        if (cliente === 'walmart' || cliente ==='walmart_parciales') {
            button = <Button
                startIcon={ <SvgIcon>
                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                </SvgIcon>}
                style={{margin:5}} disabled={this.state.seleccionados.length === 0} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("variance_walmart")}>
                Exportar Seleccionado/s
            </Button>;
        }
        else if (cliente === 'smu'){
            button = <Button
                startIcon={ <SvgIcon>
                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                </SvgIcon>}
                style={{margin:5}} disabled={this.state.seleccionados.length === 0} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("variance_smu")}>
                Exportar Seleccionado/s
            </Button>
        }
        else {
            button = <Button
                startIcon={ <SvgIcon>
                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                </SvgIcon>}
                style={{margin:5}} disabled={this.state.seleccionados.length === 0} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("variance")}>
                Exportar Seleccionado/s
            </Button>;
        }
        return(
            <div>
                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                    <Grid item>
                        { this.state.cliente !== 'sodimac' &&
                            button
                        }
                        <Button
                            startIcon={<VisibilityIcon/>} style={{margin:5}} variant="contained" color="primary" onClick={() =>this.verTagsValidados()} >
                            Tags Validados
                        </Button>
                        <Button
                            startIcon={ <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>}
                            style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("resumen_variance_categoria")}>
                            Resumen por categoría
                        </Button>
                        <Button
                            startIcon={ <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>}
                            style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("resumen_variance_subcategoria")}>
                            Resumen por subcategoría
                        </Button>
                        {  this.state.cliente === 'toyota' &&
                        <Button
                            startIcon={ <SvgIcon>
                                <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                            </SvgIcon>}
                            style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("diferencias_codigo_ordenado_por_ub")}>
                            Ordenadas por ubicación
                        </Button>
                        }
                        {  this.state.cliente === 'tottus' &&
                            <>
                            <Button
                                startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>}
                                style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("diferencias_contable")}>
                                Diferencias contable x Categoria
                            </Button>
                            <Button
                                startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>}
                                style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("diferencias_disponible")}>
                                Diferencias disponible x Categoria
                            </Button>
                             <Button
                                startIcon={ <SvgIcon>
                                    <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                                </SvgIcon>}
                                style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.enviarDatosReportes("detalle_diferencias_contable")}>
                                Detalle diferencias contable
                            </Button>
                            </>
                        }
                        {  this.state.cliente === 'sodimac' &&
                            <Button
                                startIcon={<SvgIcon>
                                    <path fill="currentColor" d="M13 17H17V14L22 18.5L17 23V20H13V17M20 4H4A2 2 0 0 0 2 6V18A2 2 0 0 0 4 20H11.35A5.8 5.8 0 0 1 11 18A6 6 0 0 1 22 14.69V6A2 2 0 0 0 20 4M20 8L12 13L4 8V6L12 11L20 6Z" />
                                </SvgIcon>}
                                style={{margin:5}} variant="contained" color="primary" onClick={ () => this.setState({enviar:true})}>
                                Enviar reconteo
                            </Button>}
                        <Button
                            startIcon={<VisibilityIcon/>} style={{margin:5}} variant="contained" color="primary" onClick={() =>this.verDetalles(null)} >
                            Conteo en cero
                        </Button>
                        {this.state.cliente === 'tottus' &&
                            <Button
                                style={{margin:5}} variant="contained" color="primary" onClick={ () =>this.agregarEnvases()}>
                                Agregar Envases
                            </Button>}

                    </Grid>
                </Grid>
                <MaterialTable
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                            nRowsSelected: "{0} fila(s) seleccionado(s)"
                        },
                        header: {
                            actions: 'Acciones',
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    isLoading={this.state.cargando}
                    options={{
                        defaultExpanded: true,
                        selection:true,
                        pageSize: 50,
                        sorting: true,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=" "
                    data={this.state.datos}
                    columns={[
                        { title: 'Descripción', field: 'descripcion',  editable:'never',},
                        { title: 'Inv. cantidad', field: 'inv', editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.inv)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.inv).indexOf(term) !== -1),
                            headerStyle: {
                            alignContent:"right",
                                textAlign: "right",
                            },
                            cellStyle:{
                                textAlign: "right",
                            }
                        },
                        { title: 'Teo. cantidad', field: 'teo',editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.teo)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.teo).indexOf(term) !== -1),
                            headerStyle: {
                                textAlign: "right"},
                            cellStyle:{
                                textAlign: "right",
                            }
                        },
                        { title: 'Dif. cantidad', field: 'dif',editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.dif)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.dif).indexOf(term) !== -1),
                            headerStyle: {
                                textAlign: "right"},
                            cellStyle:{
                                textAlign: "right",
                            }
                        },
                        { title: 'Inv. ' + this.state.titulo_columna, field: 'invimp', editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.invimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.invimp).indexOf(term) !== -1),
                            headerStyle: {
                                textAlign: "right"},
                            cellStyle:{
                                textAlign: "right",
                            }
                        },
                        { title: 'Teo. '+ this.state.titulo_columna, field: 'teoimp',editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.teoimp)),
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.teoimp).indexOf(term) !== -1),
                            headerStyle: {
                                textAlign: "right"},
                            cellStyle:{
                                textAlign: "right",
                            }
                        },
                        { title: 'Dif. '+ this.state.titulo_columna, field: 'difimp',editable:'never',  type: 'numeric',
                            render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.difimp)),
                            customSort: (a, b) => Math.abs(a.difimp) - Math.abs(b.difimp),
                            defaultSort:'desc',
                            customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.difimp).indexOf(term) !== -1),
                            headerStyle: {
                                textAlign: "right"},
                            cellStyle:{
                                textAlign: "right",
                            }
                        },
                        { title: 'Registros', field: 'registros', editable:"never", type:'numeric',
                            headerStyle: {
                                textAlign: "right"
                            },
                            cellStyle: {
                                textAlign: "right"
                            },
                        },
                        { title: 'Revisados (%)', field: 'porcentaje_revisados', editable:"never", type: 'numeric',
                            render: rowData => (Math.floor(rowData.porcentaje_revisados * 100)/100).toFixed(1),
                            customFilterAndSearch: ((term, rowData) => (Math.floor(rowData.porcentaje_revisados * 100)/100).toFixed(1).indexOf(term) !== -1),
                            headerStyle: {
                                textAlign: "right"},
                            cellStyle:{
                                textAlign: "right",
                            }},
                        { title: 'Valor', field: 'cantidad', type: 'numeric',
                            headerStyle: {
                                width: 250,
                                textAlign: "left",
                            },
                            cellStyle:{
                                width: 250,
                                textAlign: "left",
                            }
                        },
                        { title: 'Filtro', field: 'filtro', type: 'numeric',
                            headerStyle: { textAlign: "left"},
                            lookup: {1:'Monto $', 2: 'Top',3:'Top %'},
                        },

                    ]}
                    parentChildData={(row, rows) => rows.find(a => a.id === row.padre)}
                    cellEditable={{
                        onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
                            return new Promise((resolve, reject) => {
                                if(newValue > 0){
                                    if(columnDef.field === 'cantidad'){
                                        const datos = this.state.datos
                                        const index = datos.indexOf(rowData)
                                        datos[index].cantidad = newValue
                                        this.setState({datos: datos})
                                        setTimeout(resolve, 2000);
                                    }
                                    else{
                                        const datos = this.state.datos
                                        const index = datos.indexOf(rowData)
                                        datos[index].filtro = newValue
                                        this.setState({datos: datos})
                                        setTimeout(resolve, 2000);
                                    }
                                }
                                else{
                                    if(columnDef.field === 'cantidad'){
                                        const datos = this.state.datos
                                        const index = datos.indexOf(rowData)
                                        datos[index].cantidad = "-----------"
                                        this.setState({datos: datos})
                                        setTimeout(resolve, 2000);
                                    }
                                    else{
                                        const datos = this.state.datos
                                        const index = datos.indexOf(rowData)
                                        datos[index].filtro = 1
                                        this.setState({datos: datos})
                                        setTimeout(resolve, 2000);
                                    }
                                }
                            });
                        },
                    }}
                    actions={[
                        {
                            icon:  () => <SearchIcon/>,
                            tooltip: 'Ver detalle',
                            onClick: (event, rowData) => this.verDetalles(rowData),
                            position:"row"
                        },
                    ]}
                    onSelectionChange={(rows) => this.setState({seleccionados:rows})}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.enviar? <DialogEnviarCorreo refrescar={this.refrescarExportar} handleClose={this.handleClose}/>:null}
                {this.state.openExportar? <DialogExportar reporte={this.state.reporte} origen={'otro'} params={this.state.params} refrescar={this.refrescarExportar} handleClose={this.handleClose}/> : null}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}



export default withRouter(TablaDiferencias);
